import type { InputProps } from '@farmersdog/corgi-legacy';
import { Input } from '@farmersdog/corgi-legacy';

import type { ChangeEvent } from 'react';

export interface FirstNameInputProps extends Omit<InputProps, 'ref'> {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  validationMessage?: string;
}

export const FirstNameInput = ({
  value,
  onChange,
  ...props
}: FirstNameInputProps) => (
  <Input
    {...props}
    type="text"
    name="firstName"
    label="First Name"
    autoComplete="name"
    value={value}
    onChange={onChange}
  />
);
